import {HttpClient} from "@angular/common/http";
import {OfflineReferentialService} from "./offline-referential.service";
import {OnlineReferentialService} from "./online-referential.service";
import {StandaloneModeService} from "../standalone-mode.service";
import {SqliteServiceConfigRepository} from "../sqllite/repositories/params/sqlite-service-config.repository";
import {SqliteRoleParameterRepository} from "../sqllite/repositories/params/sqlite-role-parameter.repository";
import {SqliteCountryRepository} from "../sqllite/repositories/params/sqlite-country.repository";
import {SqliteAutomaticArticleRepository} from "../sqllite/repositories/params/sqlite-automatic-article.repository";
import {
    SqliteSynthesisViewConfigRepository
} from "../sqllite/repositories/params/sqlite-synthesis-view-config.repository";
import {
    SqliteNumberOfChangeStockRepository
} from "../sqllite/repositories/params/sqlite-number-of-change-stock.repository";
import {ParametersDatabase} from "../sqllite/databases/parameters.database";

export const referentialServiceFactory = (standaloneModeService: StandaloneModeService, parametersDatabase: ParametersDatabase, httpClient: HttpClient) => {
    return standaloneModeService.isOffline() ? new OfflineReferentialService(
            httpClient,
            new SqliteServiceConfigRepository(parametersDatabase),
            new SqliteRoleParameterRepository(parametersDatabase),
            new SqliteCountryRepository(parametersDatabase),
            new SqliteAutomaticArticleRepository(parametersDatabase),
            new SqliteSynthesisViewConfigRepository(parametersDatabase),
            new SqliteNumberOfChangeStockRepository(parametersDatabase)
        )
        : new OnlineReferentialService(httpClient);
};
